<script setup lang="ts">
import { inject } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const incidentId = inject<string>('incidentId', '')

const SETTING_CARDS = [
  {
    route: 'incident-settings-general',
    name: 'General',
    description: 'Mission details, dates, and incident information',
    icon: 'edit_note',
  },
  {
    route: 'incident-settings-operations',
    name: 'Operations',
    description: 'Manage operational periods and view OP statistics',
    icon: 'schedule',
  },
  {
    route: 'incident-settings-personnel',
    name: 'Personnel',
    description: 'Check-in roster and personnel management',
    icon: 'groups',
  },
  {
    route: 'incident-settings-audit',
    name: 'Audit Log',
    description: 'Full activity audit trail for this incident',
    icon: 'history',
  },
]

function navigate(routeName: string) {
  router.push({ name: routeName, params: { id: incidentId } })
}
</script>

<template>
  <div class="h-full flex flex-col overflow-hidden">
    <div class="flex items-center justify-between px-6 py-4 border-b border-border shrink-0">
      <div>
        <h2 class="font-headline font-black text-lg uppercase tracking-tight text-on-surface">Incident Settings</h2>
        <p class="font-mono text-xs text-outline mt-0.5">{{ SETTING_CARDS.length }} sections</p>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-6 pb-6 pt-4">
      <div
        v-for="card in SETTING_CARDS"
        :key="card.route"
        class="relative group bg-surface-container hover:bg-surface-container-high cursor-pointer p-4 border border-border rounded"
        @click="navigate(card.route)"
      >
        <div class="flex items-center gap-3 mb-2">
          <span class="material-symbols-outlined text-[20px] text-outline">{{ card.icon }}</span>
          <span class="text-sm font-semibold text-on-surface">{{ card.name }}</span>
        </div>
        <p class="text-xs text-outline">{{ card.description }}</p>
      </div>
    </div>
  </div>
</template>
